import { createSelector } from 'reselect';

import { AppState } from '../reducers';
import { EventFiltersState } from '../reducers/eventFilters/eventFiltersState';

export const selectEventFiltersStore = (state: AppState): EventFiltersState => state.eventFilters;
export const selectFilters = createSelector(selectEventFiltersStore, (store) => store.filter);
export const selectCollapseTrigger = createSelector(selectEventFiltersStore, (store) => store.collapseTrigger);
